<template>
  <section id="app">
    <img alt="Vue logo" src="./assets/logo.png">

    <select v-model="selected" @change="onChange($event)">
      <option value="production">Production</option>
      <option value="testing">Testing</option>
    </select>

    <section v-if="connection">
      <h1>Connection established</h1>
      <Login></Login>
      <Error></Error>
      <BackStore></BackStore>
    </section>
    
    <section v-else>
      <h1>Connection has not been stablished</h1>
      
      <div class="lds-ripple">
        <div></div>
        <div></div>
      </div>
      
      <p>Wait...connecting</p>
    </section>
  </section>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Login from "./components/Login.vue";
// ONLY WHEN DEVELOPING THE APP
import Error from "./components/Error.vue";
import BackStore from "./components/BackStore.vue";

export default {
  name: "app",
  data: {
    selected: ''
  },
  computed: {
    ...mapState(["connection"])
  },
  methods: {
    ...mapMutations(["updateConnection"]),
    onChange(e){
      this.$cookies.set('socket', e.target.value)
      location.reload();
    }
  },
  sockets: {
    connect() {
      this.updateConnection();
    }
  },
  components: {
    Login,
    Error,
    BackStore
  },
  mounted() {
    this.selected = this.$cookies.get('socket')
  }
};
</script>

<style lang="scss">
@import "./assets/reset.css";

section {
  margin: 5% auto;
  padding: 2%;
  border: 1px solid black;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  width: 80vw;
  img {
    max-height: 20vh;
  }
  .lds-ripple {
    display: inline-block;
    position: relative;
    width: 64px;
    height: 64px;
  }
  .lds-ripple div {
    position: absolute;
    border: 4px solid #3d3935;
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }
  .lds-ripple div:nth-child(2) {
    animation-delay: -0.5s;
  }
  @keyframes lds-ripple {
    0% {
      top: 28px;
      left: 28px;
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      top: -1px;
      left: -1px;
      width: 58px;
      height: 58px;
      opacity: 0;
    }
  }
}
</style>
